/** @jsx jsx */
import { LandingPage } from '@composite';
import { Layout, StaticSEO } from '@core';
import { jsx } from 'theme-ui';

const IndexPage = () => {
  return (
    <Layout invertedHeader>
      <StaticSEO pageId='home' />
      <LandingPage />
    </Layout>
  );
};

export default IndexPage;
